<template>
  <div class="app flex-row align-items-center">
    <!-- <div id="loading"></div> -->
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form name="form-login" @submit="doLogin">
                  <h1>Login</h1>
                  <p class="text-muted">Sign in to your account</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <!-- <b-form-input type="text" v-model="form.email" v-on:keyup="emailChange" class="form-control" placeholder="Email" autocomplete="email" required /> -->
                    <b-form-input type="text" v-model="form.username" class="form-control" placeholder="Email" autocomplete="username" required />
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" v-model="form.password" v-on:keyup="passwordChange" class="form-control" placeholder="Password" autocomplete="current-password" required />
                    <b-form-invalid-feedback id="input-live-feedback-password">
                      Fill Password
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button type="submit" variant="primary" class="px-4">Login</b-button>
                    </b-col>
                    <!-- <b-col cols="6" class="text-right">
                      <router-link :to="{name: 'ForgotPassword'}">
                      <b-button variant="link" class="px-0">Forgot password?</b-button>
                      </router-link>
                    </b-col> -->
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-primary py-5 d-md-down-none" style="width:44%">
              <b-card-body class="text-center">
                <div>
                  <img class="img-avatar" src="img/logo.png" alt="Tiara Buana Mandiri Logo" width=160 height=160>
                  <h2>Tiara Buana Mandiri</h2>
                  <p>Please login using registered account in system</p>
                  <!-- <b-button variant="primary" class="active mt-3">Register Now!</b-button> -->
                </div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { Service } from 'axios-middleware'
import { apiRouter } from '../../router/api-routing.js'
import { isLoggedIn, getIdToken, removeToken, getHeaderToken } from '../../user/token.js'
import { isEmailValid, stringOnly, tagPrevention } from '../../shared/input-validation.js';
import loginJson from '../../json/login.json'
var CryptoJS = require("crypto-js");
// import VueSweetalert2 from 'vue-sweetalert2';
// import 'sweetalert2/dist/sweetalert2.min.css';
// Vue.use(VueSweetalert2)

// const service = new Service(axios);

// service.register({
//   onRequest(config) {
//     console.log('onRequest');
//     return config;
//   },
//   onSync(promise) {
//     console.log('onSync');
//     return promise;
//   },
//   onResponse(response) {
//     console.log('onResponse');
//     return response;
//   }
// });

export default {
  name: 'Login',
  data(){
    return {
      loginJson: loginJson,
      form:{
        // email: '',
        username: '',
        password: '',
        client_id: process.env.CLIENT_ID_SALES,
        client_secret: process.env.CLIENT_ID_SECRET,
        grant_type: 'password'
      },
      isLoggedIn: 0
    }
  },
  computed: {
  },
  methods: {
      async doLogin(e) {
        // if (!this.emailState()){
        //   alert('Please input valid email')
        //   return
        // }

        if (!this.passwordState()){
          alert('Please input password minimum 6 character')
          return
        }

        this.showLoading()

        e.preventDefault();
        let currentObj = this

        const formData = new FormData();
        formData.append('email', stringOnly(this.form.username));
        formData.append('password', stringOnly(this.form.password));

        // axios.post(apiRouter().login, formData)
        await axios.post(apiRouter().login, this.form)
        .then((response) => {
          console.log("Response " + response);
          //console.log('inii',response.data.messages);
          if(response.status === 200){
            if(response.data.access_token){
              console.log("Login Succeed");
              //console.log(response.data.data);
              var token = response.data;
              var now = new Date().getTime()/1000;
              token.expired_token += now;
              this.getRoleId(response.data.access_token)

              // with ENCRYPT
              // try{
                // let ciphertext = CryptoJS.AES.encrypt(JSON.stringify(token), process.env.SECRET_KEY);
                // localStorage.setItem('tokenTBM', window.btoa(ciphertext));
                // console.log('tokennnn', window.btoa(ciphertext))
              // }catch (e){
              //   console.log('error', e)
              // }

              //without ENCRYPT
              localStorage.setItem('tokenTBM', JSON.stringify(token));

            } else {
              //hide loading
              this.$swal.close()
              // this.$swal('Sorry ', response.data.messages, 'error')
              this.modalOK('Login failed (please check email/password)', 'error','')
            }

          }else{
            this.modalOK('Login failed (please check email/password)', 'error','')
            //hide loading
            this.$swal.close()

          }
        })
        .catch( (error) => {
          this.$swal.close()
          this.modalOK('Login failed (please check email/password)', 'error','')
            // currentObj.output = error;
            // this.$swal('Sorry', response.data.message, 'error')
        });
      },
      async getRoleId(accessToken){

        console.log('at', accessToken)
        const configHeader = {
          headers: {
            'Authorization': 'Bearer ' + accessToken
          }
        }
        await axios.get(apiRouter().get_role + this.form.username, configHeader)
        .then((res) => {
          this.$swal.close()
          console.log('Get role', res)
          //console.log('inii',response.data.messages);
          if(res.status === 200){
              console.log("Get Role Succeed", res.data.role_id)

              // with ENCRYPT
              // let ciphertext_roleid = CryptoJS.AES.encrypt(res.data.role_id.toString(), process.env.SECRET_KEY);
              // localStorage.setItem('role_id', window.btoa(ciphertext_roleid))

              // let ciphertext_fullname = CryptoJS.AES.encrypt(res.data.fullname, process.env.SECRET_KEY);
              // localStorage.setItem('fullname', window.btoa(ciphertext_fullname))

              //without encrypt
              localStorage.setItem('role_id', res.data.role_id)
              localStorage.setItem('fullname', res.data.fullname)

              let roleId = res.data.role_id
              let roleName = ''
              if (roleId == 1){
                roleName = 'Super Admin'

              } else if (roleId == 2){
                roleName = 'Area Manager'

              } else if (roleId == 3){
                roleName = 'Agro'
              }

              localStorage.setItem('role_name', roleName)

              // let ciphertext_rolename = CryptoJS.AES.encrypt(roleName, process.env.SECRET_KEY);
              // localStorage.setItem('role_name', window.btoa(ciphertext_rolename))

              // this.$swal.close()
              if (roleId == undefined || roleId == '' || roleId == 0 || roleId > 3){
                this.modalOK('You do not have access', 'error','')
              } else {
                window.location.href = '/';
              }

          }else{
            // this.modalOK(response.data.messages, 'success', '')
            this.$swal('Sorry', res.data.messages, 'error')
          }
        })
        .catch( (error) => {
          this.$swal.close()
            // currentObj.output = error;
            // this.$swal('Sorry', response.data.message, 'error')
        });
      },
      showLoading(){
       this.$swal({
        imageUrl: require('../../assets/img/tbm_loader.gif'),
        imageWidth: 200,
        imageHeight: 200,
        background: 'none',
        imageAlt: 'Custom image',
        showConfirmButton: false
      }).then((result) => {
      });
    },
      modalOK(message, buttonVariant, page){

      this.$swal({title: message, html:'',text: '',
          type: buttonVariant,
          showCancelButton: false,
          confirmButtonText: 'OK',
          confirmButtonColor: '#4DBD74',
          showCloseButton: false,
          showLoaderOnConfirm: true,
      }).then((result) => {
        if (page == ''){
        } else {
          this.$router.replace({name: page});
        }
      });
    },
    showToast(){
      // const Toast = Swal.mixin({
      //   toast: true,
      //   position: 'top-end',
      //   showConfirmButton: false,
      //   timer: 3000
      // });

      // Toast.fire({
      //   type: 'success',
      //   title: 'Signed in successfully'
      // })
    },
    emailState(){
      // const emailRegex = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/
      // return emailRegex.test(this.form.email)
    },
    passwordState(){
      return this.form.password.length > 5 ? true : false
    },
    emailChange: function(evt){
      // this.form.email = tagPrevention(evt, this.form.email, 2)
    },
    passwordChange: function(evt){
      this.form.password = tagPrevention(evt, this.form.password, 0)
    }
  },
  mounted(){
  },
  watch: {
    isLoggedIn(newVal, oldVal){
      // console.log('wattc', newVal + oldVal)
      // console.log('isLoggedIn', isLoggedIn())
      if(newVal){
        this.$router.push({name: 'SalesManagement'});
      } else {}
    }
  },
  created(){
    // console.log('sss', process.env.SECRET_KEY)
    this.isLoggedIn = isLoggedIn()
    //console.log("isLogged in", isLoggedIn());
    // console.log("env CLIENT_ID", process.env.CLIENT_ID_SALES)
    // console.log("env CLIENT_SECRET", process.env.CLIENT_ID_SECRET)

  }
}
</script>
<style>
/* #loading{
  background: require('../../assets/img/tbm_loader.gif');
  display: block;
  width: 200px;
  height: 200px;
  position: absolute;
  z-index: 9999;
} */
</style>
